<template>
  <div class="demo-stream">
    <div ref="stream" class="stream" @click="getStats">
      <div
        class="video-stream-state"
        v-if="videoStreamState === VIDEO_STREAM_STATE.WAITING_TO_CONNECT">
        Waiting user to connect...
      </div>
      <div
        class="video-stream-state"
        v-if="videoStreamState === VIDEO_STREAM_STATE.INITIALIZING">
        Initializing...
      </div>
      <div
        class="video-stream-state"
        v-if="videoStreamState === VIDEO_STREAM_STATE.CONNECTING">
        Connecting...
      </div>
      <div
        class="video-stream-state"
        v-if="videoStreamState === VIDEO_STREAM_STATE.DISCONECTED">
        Disconnected...
      </div>
      <div
        v-if="videoStreamState === VIDEO_STREAM_STATE.ERROR_MICROPHONE_ACCESS"
        class="video-stream-state"
        @click="startVideoSession"
      >
        Error Microphone Access. Enable your mic and Click here to retry
      </div>
      <div
        v-if="videoStreamState === VIDEO_STREAM_STATE.CONNECTED"
        class="video-stream-connected"
      >
        Loading video...
      </div>

      <div class="controls" v-if="videoStreamState === VIDEO_STREAM_STATE.CONNECTED">
        <div class="control" :class="{
          muted: videoMuted
        }" @click="toggleMute">
          <fa-icon icon="volume-up"></fa-icon>
        </div>
        <div class="control" :class="{
          muted: micMuted
        }" @click="toggleMicMute">
          <fa-icon icon="microphone"></fa-icon>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import * as Video from 'twilio-video'
  import CREATE_ROOM from '../graphql/twilio-room/create-room.gql'
  import {calculateVideoClickPosition} from "../services/utils/video";
  import {VIDEO_STREAM_STATE} from "../services/modules/video-stream";
  import {throttle} from "../services/utils/helpers";

  export default {
    data: () => ({
      room: null,
      localDataTrack: null,
      videoMuted: false,
      currentElements: [],
      audioTrack: null,
      micMuted: false,
      currentParticipant: null,
      isDrawing: false,
      isPotentialDraw: false,
      videoStreamState: VIDEO_STREAM_STATE.INITIALIZING,
      VIDEO_STREAM_STATE,
      initialX: null,
      initialY: null
    }),
    mounted() {
      this.startVideoSession()
    },

    methods: {
      startVideoSession() {
        this.videoStreamState = VIDEO_STREAM_STATE.INITIALIZING;
        this.$apollo.mutate({
          mutation: CREATE_ROOM
        }).then(({data: {room}}) => {
          this.joinRoom(room)
        });
      },
      createAudioTrack() {
        return navigator.mediaDevices.enumerateDevices()
          .then(devices => {
            const audioInput = devices.find(device => device.kind === 'audioinput');
            return Video.createLocalAudioTrack({ audio: { deviceId: audioInput.deviceId }});
          })
      },
      joinRoom(roomInfo) {
        this.createAudioTrack()
          .then((audioTrack) => {
            this.audioTrack = audioTrack;
            this.localDataTrack = new Video.LocalDataTrack();

            Video.connect(roomInfo.token, {name: roomInfo.roomId, tracks: [audioTrack, this.localDataTrack]}).then(room => {
              this.room = room;

              if(room.participants.size) {
                this.videoStreamState = VIDEO_STREAM_STATE.CONNECTING;
              } else {
                this.videoStreamState = VIDEO_STREAM_STATE.WAITING_TO_CONNECT;
              }

              room.getStats()
                .then(res => {});

              room.participants.forEach(this.participantConnected);
              room.on('participantConnected', this.participantConnected);
              //
              room.on('participantDisconnected', this.participantDisconnected);
              room.once('disconnected', error => room.participants.forEach(this.participantDisconnected));
            });
          })
          .catch(() => {
            this.videoStreamState = VIDEO_STREAM_STATE.ERROR_MICROPHONE_ACCESS;
          })

      },
      participantConnected(participant) {

        this.currentParticipant = participant.identity;
        this.videoStreamState = VIDEO_STREAM_STATE.CONNECTING;

        const div = this.$refs.stream;
        div.id = participant.sid;

        this.currentElements.forEach(element => element.remove());
        this.currentElements = [];

        participant.on('trackSubscribed', track => this.trackSubscribed(div, track));
        participant.on('trackUnsubscribed', this.trackUnsubscribed);

        participant.tracks.forEach(publication => {
          if (publication.isSubscribed) {
            this.trackSubscribed(div, publication.track);
          }
        });
      },

      participantDisconnected(participant) {
        if(this.room.participants.size === 0 || this.currentParticipant === participant.identity) {
          if( this.currentParticipant === participant.identity) {
            this.videoStreamState = VIDEO_STREAM_STATE.DISCONECTED;
          } else {
            this.videoStreamState = VIDEO_STREAM_STATE.WAITING_TO_CONNECT;
          }
          setTimeout(() => {
            this.videoStreamState = VIDEO_STREAM_STATE.WAITING_TO_CONNECT;
          }, 3000);
        }

      },

      trackSubscribed(div, track) {

        if(track.kind === 'data') {
          return;
        }
        let video = track.attach();
        // video.muted = true;

        this.currentElements.push(video);

        video.addEventListener('mouseup', e => {
          if(this.isDrawing) {
            this.sendDrawStop();
          } else {
            this.sentClickData(calculateVideoClickPosition(e));
          }
          this.stopDrawing();
        });

        video.addEventListener('mousedown', e => {
          this.initialX = e.clientX;
          this.initialY = e.clientY;
          this.startPotentialDraw();
        });

        video.addEventListener('mouseleave', e => {
          if(this.isDrawing) {
            this.stopDrawing();
            this.sendDrawStop();
          }
        });

        video.addEventListener('mousemove', throttle(e => {
          this.startDrawing(e);
          if(this.isDrawing) {
            this.sentDrawData(calculateVideoClickPosition(e));
          }
        }, 50));

        div.appendChild(video);

        video.play()
          .then(res => {
            this.videoStreamState = VIDEO_STREAM_STATE.CONNECTED;
            this.videoMuted = false;
          })
          .catch(err => {
            video.muted = true;
            video.play()
              .then(() => {
                this.videoStreamState = VIDEO_STREAM_STATE.CONNECTED;
                this.videoMuted = true;
              })
              .catch(() => {

              })
          });

      },

      trackUnsubscribed(track) {
        track.detach().forEach(element => {
          try {
            element.remove()
          } catch(e) {
          }
        });
      },
      getStats() {
        if(this.room) {
          this.room.getStats()
            .then(res => {})
        }
      },

      sentClickData({originalX, originalY, videoWidth, videoHeight}) {
        let clickDataFormatted = `${originalX},${originalY},${videoWidth},${videoHeight}`;
        this.localDataTrack.send(clickDataFormatted)
      },

      sentDrawData({originalX, originalY, videoWidth, videoHeight}) {
        let clickDataFormatted = `${originalX},${originalY},${videoWidth},${videoHeight}C`;
        this.localDataTrack.send(clickDataFormatted)
      },

      sendDrawStop() {
        this.localDataTrack.send('S')
      },

      muteTracks() {
        this.currentElements.forEach((el) => {
          try {
            el.muted = true
          } catch (e) {

          }
        })
      },
      unmuteTracks() {
        this.currentElements.forEach((el) => {
          try {
            el.muted = false
          } catch (e) {

          }
        })
      },

      toggleMute() {
        if(this.videoMuted) {
          this.unmuteTracks();
        } else {
          this.muteTracks();
        }
        this.videoMuted = !this.videoMuted;
      },

      toggleMicMute() {
        if(this.micMuted) {
          this.audioTrack.enable();
        } else {
          this.audioTrack.disable()
        }
        this.micMuted = !this.micMuted;
      },

      startPotentialDraw() {
        this.isPotentialDraw = true;
      },
      startDrawing(e) {
        if(this.canBecomeDrawing(e)) {
          this.isPotentialDraw = false;
          this.isDrawing = true;
        }
      },
      stopDrawing() {
        this.isDrawing = false;
        this.isPotentialDraw = false;
      },

      canBecomeDrawing(e) {
        return this.isPotentialDraw
          && (
            Math.abs(e.clientX - this.initialX) > 5 ||
            Math.abs(e.clientY - this.initialY) > 5
          )
      }
    },
    beforeDestroy() {
      this.room && this.room.disconnect()
    }
  }
</script>

<style lang="scss">
.stream {
  height: 100vh;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  .video-stream-connected {
    position: absolute;
    z-index: 0;
    top: 50%;
    left: 50%;
    padding: 10px 15px;
    border-radius: 10px;
    transform: translate(-50%, -50%);
    background: rgba(255, 255, 255, 0.1);
    font-size: 1.2em;
    color: #ffffff;
  }

  video {
    position: relative;
    z-index: 1;
    max-width: 100%;
    max-height: 100%;

    /* Setting width & height to auto prevents the browser from stretching or squishing the video */
    width: 100%;
    height: auto;
  }

  .controls {
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    z-index: 1000;

    .control {
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 50px;
      height: 50px;
      background: #ffffff;
      color: #2a291f;
      font-size: 1.4em;
      box-shadow: 0px 0px 12px 0px rgba(42,41,31,1);
      cursor: pointer;
      margin: 0 10px;

      &.muted {
        background: #cc6057;
        color: #fff;
      }
    }
  }
}
</style>
